import apiClient from '../client/api-client'
import axios from 'axios'
const objectstore = 'objectstore'
const documents = 'documents'
const pages = 'pages'
const grantor = 'grantor'
const search = 'search'
import { baseURL } from 'config'

export default {
  /**
   * Fetches Records data based on q, named, orderBy, limit, filterDocuments and sort
   * @return {Promise}      Returns an array of Records
   */
  async fetchRecordData(payload) {
    try {
      const authToken = localStorage.getItem('default_auth_token')
      let headers = ''
      if (!authToken || payload.token) {
        headers = {
          Authorization: `Bearer ${payload.token}`,
          'Content-Type': 'application/json'
        }
        const { data } = await axios.get(`${baseURL}/${objectstore}/${documents}`, {
          headers: headers,
          params: {
            q: payload.q,
            named: payload.named,
            orderBy: payload.orderBy,
            asc: payload.asc,
            limit: payload.limit,
            offset: payload.offset,
            filterDocuments: payload.filterDocuments,
            grantor: payload.grantor
          }
        })
        return data
      } else {
        const { data } = await apiClient.get(`${objectstore}/${documents}`, {
          params: {
            q: payload.q,
            named: payload.named,
            orderBy: payload.orderBy,
            asc: payload.asc,
            limit: payload.limit,
            offset: payload.offset,
            filterDocuments: payload.filterDocuments,
            grantor: payload.grantor,
            'for-ctz-id': payload.forCtzId
          }
        })
        return data
      }
    } catch (err) {
      throw new Error(err)
    }
  },
  /**
   * Get pages for documents for pdf viewer
   * @param store
   * @param payload
   * @returns {Promise<AxiosResponse<any> | never>}
   */
  async fetchRecordPages(payload) {
    const authToken = localStorage.getItem('default_auth_token')
    if (!authToken) {
      let headers = ''
      headers = {
        Authorization: `Bearer ${payload.token}`,
        'Content-Type': 'application/json'
      }
      try {
        const { data } = await apiClient.get(`${baseURL}/${objectstore}/${pages}`, {
          headers: headers,
          params: {
            q: payload.q,
            orderBy: payload.orderBy,
            asc: payload.asc,
            limit: payload.limit,
            offset: payload.offset,
            grantor: payload.grantor,
            token: payload.token
          }
        })
        return data
      } catch (err) {
        throw new Error(err)
      }
    } else {
      try {
        const { data } = await apiClient.get(`${objectstore}/${pages}`, {
          params: {
            q: payload.q,
            orderBy: payload.orderBy,
            asc: payload.asc,
            limit: payload.limit,
            offset: payload.offset,
            grantor: payload.grantor,
            token: payload.token
          }
        })
        return data
      } catch (err) {
        throw new Error(err)
      }
    }
  },
  /**
   * Gets document by ID
   * @param store
   * @param id
   * @returns {Promise<AxiosResponse<any> | never>}
   */
  async fetchDocumentDetail(payload) {
    const authToken = localStorage.getItem('default_auth_token')
    if (!authToken) {
      let headers = ''
      headers = {
        Authorization: `Bearer ${payload.token}`,
        'Content-Type': 'application/json'
      }
      const url = payload.grantorId
        ? `${objectstore}/${documents}/${payload.id}?${grantor}=${payload.grantorId}`
        : `${objectstore}/${documents}/${payload.id}`
      try {
        const { data } = await axios.get(`${baseURL}/${url}`, {
          headers: headers
        })
        return data
      } catch (err) {
        throw new Error(err)
      }
    } else {
      const url = payload.grantorId
        ? `/${objectstore}/${documents}/${payload.id}?${grantor}=${payload.grantorId}`
        : `/${objectstore}/${documents}/${payload.id}`
      try {
        const { data } = await apiClient.get(url)
        return data
      } catch (err) {
        throw new Error(err)
      }
    }
  },
  /**
   * Search documents by query
   * @param documetnsList
   * @param query
   * @returns {Promise<AxiosResponse<any> | never>}
   */
  async searchDocuments(payload) {
    if (payload.token) {
      let headers = ''
      headers = {
        Authorization: `Bearer ${payload.token}`,
        'Content-Type': 'application/json'
      }
      try {
        const { data } = await axios.post(
          `${baseURL}/${search}`,
          {
            query: payload.query || '',
            documents: payload.documents || [],
            grantorId: payload.grantor
          },
          { headers: headers }
        )
        return data
      } catch (err) {
        throw new Error(err)
      }
    } else {
      try {
        const { data } = await apiClient.post(`${search}`, {
          query: payload.query || '',
          documents: payload.documents || []
        })
        return data
      } catch (err) {
        throw new Error(err)
      }
    }
  },
  /**
   * Get a list of documents given an array of document ids
   * @param {Object} store
   * @param {Object} share
   * @param {Array} share.documentIds
   * @param {String} share.grantor
   * @param {String} share.principal
   * @return {Promise}
   */
  async fetchDocumentsById(payload) {
    let promises = []
    const authToken = localStorage.getItem('default_auth_token')
    if (!authToken) {
      let headers = ''
      headers = {
        Authorization: `Bearer ${payload.token}`,
        'Content-Type': 'application/json'
      }
      try {
        for (let id of payload.documentIds) {
          promises.push(
            await axios.get(`${baseURL}/${objectstore}/${documents}/${id.resourceId}`, {
              headers: headers,
              params: {
                grantor: payload.grantor
              }
            })
          )
        }
        return await Promise.all(promises).then(res => res.map(r => r.data))
      } catch (err) {
        console.error(err)
      }
    } else {
      try {
        for (let id of payload.documentIds) {
          promises.push(
            apiClient.get(`${objectstore}/${documents}/${id.resourceId}`, {
              params: {
                grantor: payload.grantor
              }
            })
          )
        }
        return await Promise.all(promises).then(res => res.map(r => r.data))
      } catch (err) {
        console.error(err)
      }
    }
  },
  async fetchOrganizationById(id) {
    try {
      const { data } = await apiClient.get(`organizations/${id}`)
      return data
    } catch (error) {
      console.error(`Error trying to get organization ${id}`, error)
      throw error
    }
  }
}
